import { getCSRCookieData } from '@/app/api/CSR/getCSRCookieData'
import isHybridEnabledCSR from '@/app/api/CSR/isHybridEnabledCSR'
import { STORE_REF_ID_SEPARATOR } from '@/utils/constants'
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import { goToHome as goToHomeCSR } from './goToHome'

export const goToHomeHybridMod = (router: AppRouterInstance) => {
  let url = '/'
  const hybridAction = async () => {
    await new Promise((resolve) => setTimeout(resolve, 200))
    if (isHybridEnabledCSR()) {
      if (typeof window !== 'undefined') {
        const storeId = getCSRCookieData('_IL-storeId')
        const breakpointCode = getCSRCookieData('_IL-breakpointCode')
        const storeReference = getCSRCookieData('_IL-storeReference')

        if (storeId && breakpointCode && storeReference) {
          url = `/store/${storeReference}${STORE_REF_ID_SEPARATOR}${storeId}/${breakpointCode}`
        }
        window.location.href = url
      }
    } else {
      goToHomeCSR(router)
    }
  }

  return hybridAction()
}
